import { add, isValid } from 'date-fns';

const baseExample = {
  startAt: 'now',
  expireAt: '7d',
  origin: 'mycnc',
  title: 'Notification Title Goes Here',
  content:
    'Vulputate tellus facilisi aliquam nunc, tincidunt sit. Enim enim rhoncus amet, egestas donec iaculis mauris tellus.',
  type: 'CheckCircle',
  primaryLabel: 'Primary CTA',
  primaryUrl: '#;',
  secondaryLabel: 'Secondary CTA',
  secondaryUrl: '#;',
  startAtDate: new Date(),
};

export default (data = baseExample) => {
  const startAt = isValid(data.startAtDate) ? data.startAtDate : new Date();
  const expireAt = isValid(data.expireAtDate) ? data.expireAtDate : add(startAt || new Date(), { days: 7 })
  const notification = {
    referenceId: 'someId',
    applicationId: data.origin || baseExample.origin,
    title: data.title || baseExample.title,
    content: data.content || baseExample.content,
    settings: {
      unread: true,
      icon: data.type,
      ...(data.primaryLabel
        ? {
            urlAction1: {
              label: data.primaryLabel,
              url: data.primaryUrl || '#;',
            },
          }
        : {}),
      ...(data.secondaryLabel
        ? {
            urlAction2: {
              label: data.secondaryLabel,
              url: data.secondaryUrl || '#;',
            },
          }
        : {}),
    },
    ...(startAt ? { startAt: startAt.getTime() } : {}),
    ...(expireAt ? { expireAt: expireAt.getTime() } : {}),
  };

  return notification;
};
